import { QueryResult, useQuery, OperationVariables } from '@apollo/client';
import GET_STUDENT_ASSESSMENT_SCORES from 'graph/queries/student-assessment/get-student-assessment-scores';
import { StoreTypename, StudentAssessment } from 'types';

export type StudentAssessmentScoresState = {
  studentAssessments: StudentAssessment[];
  isLoading: boolean;
};

export type StudentAssessmentScoresDispatch = {
  studentAssessmentScoresRefetch: any;
};

export type StudentAssessmentScoresStore = [
  StudentAssessmentScoresState,
  StudentAssessmentScoresDispatch
];

export const getDefaultStudentAssessmentScoresStoreState = (): any => ({
  __typename: StoreTypename.STUDENT_ASSESSMENT_SCORES,
});

const useStudentAssessmentScoresStore = (
  studentId: number[],
  assessmentIds: number[]
): StudentAssessmentScoresStore => {
  const {
    data,
    loading,
    refetch: studentAssessmentScoresRefetch,
  }: QueryResult<{
    studentAssessments: StudentAssessment[];
  }> = useQuery(GET_STUDENT_ASSESSMENT_SCORES, {
    fetchPolicy: 'no-cache',
    variables: {
      where: {
        studentId: studentId,
        assessmentId: assessmentIds,
      },
    } as OperationVariables,
  });

  return [
    {
      studentAssessments: data?.studentAssessments ?? [],
      isLoading: loading,
    },
    {
      studentAssessmentScoresRefetch,
    },
  ];
};

export default useStudentAssessmentScoresStore;
